import request from '../servises/request'

export function getScans (pr) {
  let params
  if (pr) {
    params = `?${pr}`
  }
  return request({
    url: pr ? `/scan${params}` : '/scan',
    method: 'GET',
  })
}

export function deleteScan (scan_id) {
  console.log(scan_id)
  return request({
    url: `/scan/${scan_id}`,
    method: 'DELETE',
  })
}

export function scanShow (scan_id) {
  return request({
    url: `/scan/${scan_id}`,
    method: 'GET',
  })
}

export function updateScan (data) {
  return request({
    url: `/scan/${data.id}`,
    method: 'PATCH',
    data: data
  })
}

export function finishScan(scanId) {
  console.log(scanId);
  return request({
    url: `/scan/finish/${scanId}`,
    method: 'POST',
    data: {}
  });
}

export function suspendAllScan() {
  return request({
    url: `/scan/suspend-all`,
    method: 'PATCH',
  })
}

export function reloadScan(data){
  console.log(data.id)
  return request({
    url: `/scan/${data.id}/reload`,
    method: 'POST',
  })
}

export function createScan (data) {
  return request({
    url: `/scan`,
    method: 'POST',
    data: data

  })
}
